module.exports = __webpack_public_path__ + "static/assets/27de73415af0055c69a40377fa1af06e.png";